import styled from "styled-components";

export const MobileMenuWrap = styled.div`
    position: fixed;
    top: 91px;
    left: 0;
    width: 100%;
    background: white;
    z-index: 1;
    flex-direction: column;
    font-size: 16px;
    overflow-y: auto;
    display: none;
    max-height: ${({$isMenuOpen})=>$isMenuOpen?'100%': '0'};
    transition: 0.2s;
    @media screen and (max-width: 1140px){
        display: flex;
    }
`;